import React from "react";
import "../../../css/AreaGobierno/concejo-deliberante.css";

const ConcejoDeliberante = () => (
  <div className="container my-5">
    <h2 className="text-center" style={{ color: "#137158", fontWeight: "bold", marginBottom: "2rem" }}>
      CONCEJO DELIBERANTE
    </h2>

    <h4 className="text-center mb-4" style={{ color: "#333" }}>
      Conocé cada una de las áreas que conforman el Gobierno de la Ciudad de Oliva.
    </h4>

    <div className="poder-ejecutivo text-center" style={{ width: "60%", margin: "auto" }}>
      <a
        href={require("../../img/legislativo.jpg")}
        target="_blank"
        rel="noopener noreferrer"
        title="Poder Legislativo"
        className="fancybox"
      >
        <img
          src={require("../../img/legislativo.jpg")}
          alt="Poder Legislativo"
          className="img-fluid"
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(44,62,80,0.10)",
            maxWidth: "100%",
            marginBottom: "1.5rem"
          }}
        />
      </a>
      
    </div>
  </div>
);

export default ConcejoDeliberante;